'use client';
import React from 'react';
//import { DFPManager } from 'react-dfp';
import { raptiveAdManager } from '../raptive';

export const usePageTargeting = (targeting: Record<string, string | string[]>, appendRaptiveTarget?: boolean) => {
  React.useEffect(() => {
    if (!targeting) return;
    if (appendRaptiveTarget) {
      window['raptivetarget'] = { ...(window['raptivetarget'] || {}), ...(targeting || {}) };
      raptiveAdManager.setTargeting(targeting);
    }
    // DFPManager.setTargetingArguments(targeting);
    // DFPManager.load();
    return () => {
      if (window['raptivetarget']) {
        window['raptivetarget'] = {};
      }
      //DFPManager.setTargetingArguments({});
    };
  }, [targeting, appendRaptiveTarget]);
};
